import React from 'react'
import Recognised from '../career/Recognised'
import ClientSpeackData from '../Component/ClientSpeackData'

function CombineAbout() {
  return (
    <>
    <div className='imgba'>

        <Recognised/>
        <ClientSpeackData/>
    </div>
    </>
  )
}

export default CombineAbout;
